var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBooksB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.02592 14.6908L3.09782 2.9404C3.13663 2.71989 3.21849 2.50919 3.33874 2.32033C3.45899 2.13147 3.61527 1.96815 3.79865 1.83969C3.98203 1.71124 4.18892 1.62017 4.4075 1.57169C4.62608 1.52321 4.85207 1.51827 5.07256 1.55714L15.1448 3.33415C15.59 3.41272 15.9858 3.6649 16.245 4.03523C16.5043 4.40556 16.6058 4.86371 16.5272 5.30889L14.4553 17.0593C14.4165 17.2798 14.3347 17.4905 14.2144 17.6794C14.0942 17.8682 13.9379 18.0316 13.7545 18.16C13.5711 18.2885 13.3643 18.3795 13.1457 18.428C12.9271 18.4765 12.7011 18.4814 12.4806 18.4426L2.40833 16.6656C1.96315 16.587 1.56741 16.3348 1.30817 15.9645C1.04892 15.5941 0.947394 15.136 1.02592 14.6908Z",
    stroke: "#23272E",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.15892 5.20996L12.8741 6.39378M5.56658 8.5671L12.2817 9.75178M4.9751 11.9242L9.17174 12.6649",
    stroke: "#23272E",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBooksB);
export default __webpack_public_path__ + "static/media/BooksB.68fcf4d26905f8ce023e7f404f569bf7.svg";
export { ForwardRef as ReactComponent };